// First-attachment tag onboarding (native): when the user attaches a photo or
// document for the first time, walk them through tagging it — Step 1 "Tag It"
// at the # button, Step 2 "Project vs Task" in the tag list, Step 3 "That's a
// tag" over the placed tag, then a "Saved to <project>" success label after
// the first tagged message is sent. Mirrors the web flow in ChatDetail.tsx.

export type UploadTagOnboardingStep =
  // flow not running
  | 'idle'
  // Step 1/3 — "Tag It" tooltip at the # button
  | 'attachTooltip'
  // Step 2/3 — "Project vs Task" tooltip in the tag list modal
  | 'tagList'
  // Step 3/3 — "That's a tag" tooltip over the tag in the composer
  | 'tagPlaced';

export const shouldTriggerUploadOnboarding = (
  firstTagUsed: boolean,
  alreadyFired: boolean
): boolean => !firstTagUsed && !alreadyFired;

/** Photos and documents are taggable; audio memos are not. */
export const hasTaggableAttachment = (
  files: { isAudio?: boolean | null }[] | undefined
): boolean => !!files?.some((f) => !f.isAudio);

export const firstTagProjectNameOf = (
  tagsCollection: { project?: { name?: string | null } | null }[] | undefined
): string => tagsCollection?.[0]?.project?.name ?? '';
